var isConnectHttpError = function (error) {
    // tslint:disable-next-line:no-unnecessary-type-assertion
    if (error.errorCode) {
        return true;
    }
    return false;
};

export { isConnectHttpError };
